import SubHeader from "../../components/elements/SubHeader";
import Sidebar from "../../components/plan-copy/Sidebar";
import SubNav from "../../components/plan-template/SubNav";
import ListContent from "../../components/plan-copy/ListContent";
import { useEffect, useMemo, useRef, useState } from "react";
import CopyContentModal from "../../components/popups/plan-copy/CopyContentPopup";
import { useLoaderData } from "react-router-dom";
import LayoutSidebar from "../../components/layout/LayoutSidebar";
import { getListCopiers, copyOrganization } from "../../services/organizations.service";
import usePlanCopyConf from "../../hooks/plan-copy-conf.hook";
import CrudContentModal from "../../components/popups/plan-copy/CrudContentPopup";
import ConfirmModal from "../../components/popups/ConfirmPopup";
import LoaderPage from "../../components/utils/LoaderPage";
import ActionBtnItem from "../../components/utils/ActionBtnItem";
import { formatOrganizationPlanCopyContentObject } from "../../helper/formatter.helper";
import EmptyTemplate from "../../components/emptystate/EmptyTemplate";
import useNotification from "../../hooks/notification.hook";
import { cn } from "../../lib/utils";
import {
	getAllOrganizationsList,
	getAllOrganizationTypesList,
	getAllResellersList,
} from "../../helper/data.helper";
import { OrganizationsPickerContextProvider } from "../../context/organizations-picker.context";

function PlanCopyConf() {
	const loaderData = useLoaderData();

	const {
		crudConfOpen,
		setCrudConfOpen,
		copyPopup,
		setCopyPopup,
		planChapters,
		setPlanChapters,
		planData,
		setPlanData,

		listConfs,
		setListConfs,

		selectedConf,
		selectedConfId,

		deleteModalOpen,
		setDeleteModalOpen,

		deleteConf,

		deleteItem,
		updateListConf,
		updateShowedConf,

		listOrganizations,
		setListOrganizations,

		crudModel,
		loadingCopyPlan,
		setLoadingCopyPlan,

		deleteConfRequest,
		editConfRequest,
		selectedOrganization,

		mode,
	} = usePlanCopyConf();

	const { openNotification, helperErrorNotification } = useNotification();

	const [isImporting, setIsImporting] = useState(false);
	const [isImportConfirmOpen, setIsImportConfirmOpen] = useState(false);
	const signalCopiers = useRef(new AbortController());

	const importHandler = () => {
		if (!isImporting) {
			setIsImporting(true);
			const body = {
				idCorp: selectedOrganization?.organization?.id,
				idPlan: selectedOrganization?.plan?.id,
				organization_plan_ids: [loaderData.plan.id],
				...(selectedConfId && { copier_id: selectedConfId }),
			};

			// copy conf
			copyOrganization(
				body,
				() => {
					openNotification({
						text: "Operazione completata con successo!",
						status: "success",
					});
					setIsImporting(false);
					setIsImportConfirmOpen(false);
				},
				(err) => {
					helperErrorNotification(err);
					setIsImporting(false);
				}
			);
		}
	};

	const mainCtaHandler = async () => {
		if (mode === "export") {
			if (!listOrganizations?.length) getListOrganizations();
			if (!orgTypes?.length) getTypes();
			if (!resellers?.length) getListResellers();
			setCopyPopup(true);
		} else {
			setIsImportConfirmOpen(true);
		}
	};

	const templateRight = () => (
		<button
			type="button"
			onClick={mainCtaHandler}
			disabled={!selectedOrganization.organization}
			className={cn("button fill primary small", !selectedOrganization.organization && "disabled")}
		>
			Procedi
		</button>
	);

	const [orgTypes, setOrgTypes] = useState([]);

	const [resellers, setResellers] = useState([]);

	const [loadingData, setLoadingData] = useState({
		organizations: false,
		types: false,
		resellers: false,
	});

	/**
	 * Get list copiers
	 */
	const getCopiers = () => {
		signalCopiers.current.abort();
		signalCopiers.current = new AbortController();
		setLoadingCopyPlan((l) => ({ ...l, copiers: true }));
		setListConfs([]);
		const body = {
			id: selectedOrganization?.organization?.id ?? 0,
			idPlan: selectedOrganization?.plan?.id ?? 0,
		};

		getListCopiers({ params: body, config: { signal: signalCopiers.current.signal } }, (res) => {
			setListConfs(res.data);
			setLoadingCopyPlan((l) => ({ ...l, copiers: false }));
		});
	};

	/**
	 * Get List organizations
	 */
	const getListOrganizations = async () => {
		setLoadingData((l) => ({ ...l, organizations: true }));
		const filters = {
			template_plan_id: loaderData.plan.template_plan_id,
			include: ["organizationType", "reseller", "organizationPlans"],
			filter: {
				template_plan_active: true,
			},
		};
		const organizations = await getAllOrganizationsList(filters);
		setLoadingData((l) => ({ ...l, organizations: false }));
		setListOrganizations(organizations);
	};

	/**
	 * Get Types
	 */
	const getTypes = async () => {
		setLoadingData((l) => ({ ...l, types: true }));
		const types = await getAllOrganizationTypesList();
		setOrgTypes(types);
		setLoadingData((l) => ({ ...l, types: false }));
	};

	/**
	 * Get List resellers
	 */
	const getListResellers = async () => {
		// Fetch Api
		setLoadingData((l) => ({ ...l, resellers: true }));
		const resellers = await getAllResellersList();
		setResellers(resellers);
		setLoadingData((l) => ({ ...l, resellers: false }));
	};

	/**
	 * Init data
	 */
	useEffect(() => {
		setPlanChapters(loaderData.plan.organization_contents);
		setPlanData(loaderData.plan);
	}, []);

	/**
	 * Fetch data
	 */
	useEffect(() => {
		if (selectedOrganization?.organization?.id) {
			getCopiers();

			if (selectedConf) {
				updateShowedConf(selectedConf.id);
			}
		}
	}, [updateListConf, selectedOrganization?.organization?.id]);

	const titleSubHeader = selectedConf
		? `Configurazione – ${selectedConf.name}`
		: `Tutto il contenuto – ${loaderData.plan.template_plan.name}`;

	const filteredOrganizations = listOrganizations.filter(
		(corp) =>
			corp.id !== loaderData.plan.organization_id &&
			corp.organization_plans.length > 0 &&
			corp.organization_plans[0].template_plan_id === loaderData.plan.template_plan_id
	);

	/**
	 * Template Nav
	 * @returns
	 */
	const templateNav = () => (
		<div className="main_comp_actions_group">
			{/* Status */}
			<div className="main_list_counter">
				{/* Contents counter */}
				<div className="main_counter">
					<div className="main_icon">
						<span className="icon_16 default text_box"></span>
					</div>
					{selectedConf != null
						? selectedConf?.copier_chapter_contents_count
						: (selectedOrganization?.plan?.organization_chapter_contents_count ?? 0)}
				</div>

				{/* Requirements counter */}
				<div className="main_counter">
					<div className="main_icon">
						<span className="icon_16 default layer"></span>
					</div>
					{selectedConf != null
						? selectedConf?.copier_requirements_count
						: (selectedOrganization?.plan?.organization_requirements_count ?? 0)}
				</div>
			</div>

			{/* Actions */}
			{selectedConf != null && (
				<div className="main_actions">
					<ActionBtnItem
						icon="edit"
						onClick={() => editConfRequest(selectedConf)}
						tooltip="Modifica"
					/>

					<ActionBtnItem
						icon="delete"
						onClick={() => deleteConfRequest(selectedConf)}
						tooltip="Elimina"
					/>
				</div>
			)}
		</div>
	);

	/**
	 * Filter list
	 * @returns
	 */
	const filteredList = useMemo(() => {
		const chapters = selectedOrganization?.plan?.organization_chapters
			? JSON.parse(JSON.stringify(selectedOrganization?.plan?.organization_chapters))
			: [];

		const processedChapters = chapters.map((chapter) => {
			const filteredContents = chapter.organization_chapter_contents.filter(
				(content) => content.template_chapter_content.editable
			);

			const filteredGoals = chapter.organization_goals.filter(
				(goal) => goal.organization_requirements.length > 0
			);

			return {
				...chapter,
				organization_chapter_contents: filteredContents,
				organization_goals: filteredGoals,
			};
		});

		return processedChapters.filter(
			(chapter) =>
				chapter.organization_chapter_contents.length > 0 || chapter.organization_goals.length > 0
		);
	}, [JSON.stringify(selectedOrganization?.plan?.organization_chapters)]);

	return (
		<LayoutSidebar>
			<SubHeader
				title="Gestione contenuto"
				titleSmall
				back
				TemplateRightContent={templateRight}
				tagElement={{
					name: loaderData.plan.organization.name,
					image: loaderData.plan.organization.logo_url,
					icon: "entity",
				}}
				note={loaderData.plan.template_plan.name}
			/>

			<Sidebar configurations={listConfs} disableCreate={!filteredList?.length} />

			<div className="main_page_sidebar white_page relative">
				{!selectedOrganization.organization ? (
					<EmptyTemplate
						className={{ image: "!w-[230px]" }}
						image="/images/empty/empty-list.svg"
						title="Seleziona un ente"
						description="Qui vedrai l’anteprima del contenuto da importare"
					/>
				) : (
					<>
						<SubNav
							heading={titleSubHeader}
							TemplateRightContent={templateNav}
							wrapperClassName="border-b border-dark-10"
						/>

						<div
							className={`wrap_page_sidebar relative${loadingCopyPlan.showDetail ? " block_scroll" : ""}`}
						>
							{planChapters && <ListContent chapters={planChapters} />}
						</div>
						{loadingCopyPlan.showDetail && <LoaderPage title="Caricamento..." section />}
					</>
				)}
			</div>

			{/* Copy modal */}
			<OrganizationsPickerContextProvider
				organizations={filteredOrganizations}
				types={orgTypes}
				resellers={resellers}
			>
				<CopyContentModal
					organizations={filteredOrganizations}
					plan={planData}
					selectedConfId={selectedConfId}
					open={copyPopup}
					types={orgTypes}
					loadingData={loadingData}
					setOpen={setCopyPopup}
				/>
			</OrganizationsPickerContextProvider>

			{/* Crud modal content */}
			{planChapters && (
				<CrudContentModal
					confModel={crudModel}
					template={formatOrganizationPlanCopyContentObject(planChapters)}
					open={crudConfOpen}
					setOpen={setCrudConfOpen}
					organization={selectedOrganization?.organization}
				/>
			)}

			{/* Confirm content */}
			<ConfirmModal
				open={deleteModalOpen}
				setOpen={setDeleteModalOpen}
				title={deleteConf.title}
				icon={deleteConf.icon}
				subtitle={deleteConf.subtitle}
				description={deleteConf.description}
				alertMessage="Attenzione! Questa operazione è irreversibile! <b>Sei sicuro di procedere?</b>"
				ctaLabel="Elimina"
				onConfirm={() => deleteConf.confirmHandler(deleteItem)}
			/>

			{/* Confirm import */}
			<ConfirmModal
				open={isImportConfirmOpen}
				setOpen={setIsImportConfirmOpen}
				title={"Importazione dei contenuti"}
				subtitle={loaderData.plan?.organization?.name}
				description={`Stai per importare i contenuti selezionati da: ${selectedOrganization?.organization?.name}`}
				alertMessage="Attenzione! Questa operazione è irreversibile! <b>Sei sicuro di procedere?</b>"
				ctaLabel="Conferma"
				isSuccess={true}
				onConfirm={importHandler}
				isLoading={isImporting}
			/>

			{loadingCopyPlan.planInfo && <LoaderPage title="Caricamento..." />}
		</LayoutSidebar>
	);
}

export default PlanCopyConf;
